'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {

    var columns = [{
        Header: 'Id',
        accessor: 'id'
    }, {
        Header: 'Título',
        accessor: 'title'
    }, {
        Header: 'Descrição',
        accessor: 'description'
    }, {
        Header: 'Texto Notificação',
        accessor: 'headline'
    }, {
        Header: 'Enviar em',
        Cell: function Cell(col) {
            return _react2.default.createElement(
                'span',
                null,
                col.original.sendDate ? (0, _moment2.default)(col.original.sendDate).format('DD/MM/YYYY HH:mm') : '-'
            );
        }
    }, {
        Header: 'Enviada em',
        Cell: function Cell(col) {
            return _react2.default.createElement(
                'span',
                null,
                col.original.sentAt ? (0, _moment2.default)(col.original.sentAt).format('DD/MM/YYYY HH:mm') : '-'
            );
        }
    }, {
        Header: 'Criada em',
        accessor: 'createdAt',
        Cell: function Cell(col) {
            return _react2.default.createElement(
                'span',
                null,
                (0, _moment2.default)(col.original.createdAt).format('DD/MM/YYYY HH:mm')
            );
        }
    }, {
        id: 'edit',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickEditHint(col.original.id);
                    } },
                'edit'
            );
        }
    }, {
        id: 'deeplink',
        width: 62,
        Cell: function Cell(col) {
            return _react2.default.createElement(
                _IconButton2.default,
                { iconClassName: 'material-icons', onClick: function onClick() {
                        return props.onClickDeepLink(col.original.id);
                    } },
                'link'
            );
        }
    }];

    return _react2.default.createElement(_reactTable2.default, {
        data: props.hints,
        columns: columns,
        loading: props.loading,
        previousText: 'Anterior',
        nextText: 'Pr\xF3xima',
        loadingText: 'Carregando...',
        noDataText: 'N\xE3o foram encontradas dicas para este filtro',
        pageText: 'P\xE1gina',
        ofText: 'de',
        rowsText: 'linhas'
    });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9oaW50cy9IaW50TGlzdC5qcyJdLCJuYW1lcyI6WyJwcm9wcyIsImNvbHVtbnMiLCJIZWFkZXIiLCJhY2Nlc3NvciIsIkNlbGwiLCJjb2wiLCJvcmlnaW5hbCIsInNlbmREYXRlIiwiZm9ybWF0Iiwic2VudEF0IiwiY3JlYXRlZEF0IiwiaWQiLCJ3aWR0aCIsIm9uQ2xpY2tFZGl0SGludCIsIm9uQ2xpY2tEZWVwTGluayIsImhpbnRzIiwibG9hZGluZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztrQkFFZSxVQUFDQSxLQUFELEVBQVc7O0FBRXRCLFFBQU1DLFVBQVUsQ0FBQztBQUNiQyxnQkFBUSxJQURLO0FBRWJDLGtCQUFVO0FBRkcsS0FBRCxFQUdiO0FBQ0NELGdCQUFRLFFBRFQ7QUFFQ0Msa0JBQVU7QUFGWCxLQUhhLEVBTWI7QUFDQ0QsZ0JBQVEsV0FEVDtBQUVDQyxrQkFBVTtBQUZYLEtBTmEsRUFTYjtBQUNDRCxnQkFBUSxtQkFEVDtBQUVDQyxrQkFBVTtBQUZYLEtBVGEsRUFZYjtBQUNDRCxnQkFBUSxXQURUO0FBRUNFLGNBQU0sY0FBQ0MsR0FBRDtBQUFBLG1CQUFTO0FBQUE7QUFBQTtBQUFRQSxvQkFBSUMsUUFBSixDQUFhQyxRQUFiLEdBQXdCLHNCQUFPRixJQUFJQyxRQUFKLENBQWFDLFFBQXBCLEVBQThCQyxNQUE5QixDQUFxQyxrQkFBckMsQ0FBeEIsR0FBbUY7QUFBM0YsYUFBVDtBQUFBO0FBRlAsS0FaYSxFQWViO0FBQ0NOLGdCQUFRLFlBRFQ7QUFFQ0UsY0FBTSxjQUFDQyxHQUFEO0FBQUEsbUJBQVM7QUFBQTtBQUFBO0FBQVFBLG9CQUFJQyxRQUFKLENBQWFHLE1BQWIsR0FBc0Isc0JBQU9KLElBQUlDLFFBQUosQ0FBYUcsTUFBcEIsRUFBNEJELE1BQTVCLENBQW1DLGtCQUFuQyxDQUF0QixHQUErRTtBQUF2RixhQUFUO0FBQUE7QUFGUCxLQWZhLEVBa0JiO0FBQ0NOLGdCQUFRLFdBRFQ7QUFFQ0Msa0JBQVUsV0FGWDtBQUdDQyxjQUFNLGNBQUNDLEdBQUQ7QUFBQSxtQkFBUztBQUFBO0FBQUE7QUFBUSxzQ0FBT0EsSUFBSUMsUUFBSixDQUFhSSxTQUFwQixFQUErQkYsTUFBL0IsQ0FBc0Msa0JBQXRDO0FBQVIsYUFBVDtBQUFBO0FBSFAsS0FsQmEsRUFzQmI7QUFDQ0csWUFBSSxNQURMO0FBRUNDLGVBQU8sRUFGUjtBQUdDUixjQUFNLGNBQUNDLEdBQUQ7QUFBQSxtQkFBUztBQUFDLG9DQUFEO0FBQUEsa0JBQVksZUFBYyxnQkFBMUIsRUFBMkMsU0FBUztBQUFBLCtCQUFNTCxNQUFNYSxlQUFOLENBQXNCUixJQUFJQyxRQUFKLENBQWFLLEVBQW5DLENBQU47QUFBQSxxQkFBcEQ7QUFBQTtBQUFBLGFBQVQ7QUFBQTtBQUhQLEtBdEJhLEVBMEJiO0FBQ0NBLFlBQUksVUFETDtBQUVDQyxlQUFPLEVBRlI7QUFHQ1IsY0FBTSxjQUFDQyxHQUFEO0FBQUEsbUJBQVM7QUFBQyxvQ0FBRDtBQUFBLGtCQUFZLGVBQWMsZ0JBQTFCLEVBQTJDLFNBQVM7QUFBQSwrQkFBTUwsTUFBTWMsZUFBTixDQUFzQlQsSUFBSUMsUUFBSixDQUFhSyxFQUFuQyxDQUFOO0FBQUEscUJBQXBEO0FBQUE7QUFBQSxhQUFUO0FBQUE7QUFIUCxLQTFCYSxDQUFoQjs7QUFnQ0EsV0FDSSw4QkFBQyxvQkFBRDtBQUNJLGNBQU1YLE1BQU1lLEtBRGhCO0FBRUksaUJBQVNkLE9BRmI7QUFHSSxpQkFBU0QsTUFBTWdCLE9BSG5CO0FBSUksc0JBQWEsVUFKakI7QUFLSSxrQkFBUyxZQUxiO0FBTUkscUJBQVksZUFOaEI7QUFPSSxvQkFBVyxpREFQZjtBQVFJLGtCQUFTLFdBUmI7QUFTSSxnQkFBTyxJQVRYO0FBVUksa0JBQVM7QUFWYixNQURKO0FBY0gsQyIsImZpbGUiOiJIaW50TGlzdC5qcyIsInNvdXJjZVJvb3QiOiIvc3JjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBNb21lbnQgZnJvbSAnbW9tZW50JztcbmltcG9ydCBSZWFjdFRhYmxlIGZyb20gJ3JlYWN0LXRhYmxlJztcbmltcG9ydCBJY29uQnV0dG9uIGZyb20gJ21hdGVyaWFsLXVpL0ljb25CdXR0b24nO1xuXG5leHBvcnQgZGVmYXVsdCAocHJvcHMpID0+IHtcblxuICAgIGNvbnN0IGNvbHVtbnMgPSBbe1xuICAgICAgICBIZWFkZXI6ICdJZCcsXG4gICAgICAgIGFjY2Vzc29yOiAnaWQnXG4gICAgfSwge1xuICAgICAgICBIZWFkZXI6ICdUw610dWxvJyxcbiAgICAgICAgYWNjZXNzb3I6ICd0aXRsZSdcbiAgICB9LCB7XG4gICAgICAgIEhlYWRlcjogJ0Rlc2NyacOnw6NvJyxcbiAgICAgICAgYWNjZXNzb3I6ICdkZXNjcmlwdGlvbidcbiAgICB9LCB7XG4gICAgICAgIEhlYWRlcjogJ1RleHRvIE5vdGlmaWNhw6fDo28nLFxuICAgICAgICBhY2Nlc3NvcjogJ2hlYWRsaW5lJ1xuICAgIH0sIHtcbiAgICAgICAgSGVhZGVyOiAnRW52aWFyIGVtJyxcbiAgICAgICAgQ2VsbDogKGNvbCkgPT4gPHNwYW4+eyBjb2wub3JpZ2luYWwuc2VuZERhdGUgPyBNb21lbnQoY29sLm9yaWdpbmFsLnNlbmREYXRlKS5mb3JtYXQoJ0REL01NL1lZWVkgSEg6bW0nKSA6ICctJyB9PC9zcGFuPlxuICAgIH0sIHtcbiAgICAgICAgSGVhZGVyOiAnRW52aWFkYSBlbScsXG4gICAgICAgIENlbGw6IChjb2wpID0+IDxzcGFuPnsgY29sLm9yaWdpbmFsLnNlbnRBdCA/IE1vbWVudChjb2wub3JpZ2luYWwuc2VudEF0KS5mb3JtYXQoJ0REL01NL1lZWVkgSEg6bW0nKSA6ICctJyB9PC9zcGFuPlxuICAgIH0sIHtcbiAgICAgICAgSGVhZGVyOiAnQ3JpYWRhIGVtJyxcbiAgICAgICAgYWNjZXNzb3I6ICdjcmVhdGVkQXQnLFxuICAgICAgICBDZWxsOiAoY29sKSA9PiA8c3Bhbj57IE1vbWVudChjb2wub3JpZ2luYWwuY3JlYXRlZEF0KS5mb3JtYXQoJ0REL01NL1lZWVkgSEg6bW0nKSB9PC9zcGFuPlxuICAgIH0sIHtcbiAgICAgICAgaWQ6ICdlZGl0JyxcbiAgICAgICAgd2lkdGg6IDYyLFxuICAgICAgICBDZWxsOiAoY29sKSA9PiA8SWNvbkJ1dHRvbiBpY29uQ2xhc3NOYW1lPVwibWF0ZXJpYWwtaWNvbnNcIiBvbkNsaWNrPXsoKSA9PiBwcm9wcy5vbkNsaWNrRWRpdEhpbnQoY29sLm9yaWdpbmFsLmlkKX0+ZWRpdDwvSWNvbkJ1dHRvbj5cbiAgICB9LCB7XG4gICAgICAgIGlkOiAnZGVlcGxpbmsnLFxuICAgICAgICB3aWR0aDogNjIsXG4gICAgICAgIENlbGw6IChjb2wpID0+IDxJY29uQnV0dG9uIGljb25DbGFzc05hbWU9XCJtYXRlcmlhbC1pY29uc1wiIG9uQ2xpY2s9eygpID0+IHByb3BzLm9uQ2xpY2tEZWVwTGluayhjb2wub3JpZ2luYWwuaWQpfT5saW5rPC9JY29uQnV0dG9uPlxuICAgIH1dO1xuXG4gICAgcmV0dXJuIChcbiAgICAgICAgPFJlYWN0VGFibGVcbiAgICAgICAgICAgIGRhdGE9e3Byb3BzLmhpbnRzfVxuICAgICAgICAgICAgY29sdW1ucz17Y29sdW1uc31cbiAgICAgICAgICAgIGxvYWRpbmc9e3Byb3BzLmxvYWRpbmd9XG4gICAgICAgICAgICBwcmV2aW91c1RleHQ9XCJBbnRlcmlvclwiXG4gICAgICAgICAgICBuZXh0VGV4dD1cIlByw7N4aW1hXCJcbiAgICAgICAgICAgIGxvYWRpbmdUZXh0PVwiQ2FycmVnYW5kby4uLlwiXG4gICAgICAgICAgICBub0RhdGFUZXh0PVwiTsOjbyBmb3JhbSBlbmNvbnRyYWRhcyBkaWNhcyBwYXJhIGVzdGUgZmlsdHJvXCJcbiAgICAgICAgICAgIHBhZ2VUZXh0PVwiUMOhZ2luYVwiXG4gICAgICAgICAgICBvZlRleHQ9XCJkZVwiXG4gICAgICAgICAgICByb3dzVGV4dD1cImxpbmhhc1wiXG4gICAgICAgIC8+XG4gICAgKTtcbn1cbjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/components/hints/HintList.js
// module id = 2339
// module chunks = 0